export default __webpack_public_path__ + "static/media/removed-from-blacklist.2ccc1992.svg";